import { render } from "./NewslettersView.vue?vue&type=template&id=1f131b55&scoped=true"
import script from "./NewslettersView.vue?vue&type=script&lang=js"
export * from "./NewslettersView.vue?vue&type=script&lang=js"

import "./NewslettersView.vue?vue&type=style&index=0&id=1f131b55&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f131b55"]])

export default __exports__